import { render, staticRenderFns } from "./PhilHome.vue?vue&type=template&id=23e61942&scoped=true&"
import script from "./PhilHome.vue?vue&type=script&lang=js&"
export * from "./PhilHome.vue?vue&type=script&lang=js&"
import style0 from "./PhilHome.vue?vue&type=style&index=0&id=23e61942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e61942",
  null
  
)

export default component.exports